<app-header></app-header>
<div class="responsive">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-3">
        <app-sidebar></app-sidebar>
      </div>
      <div class="col-md-9">
        <div class="row margin-b">
          <div class="col-md-12">
            <div class="section-bar margin-b">
              <button class="icon-btn" title="Back">
                <i class="fas fa-arrow-left"></i>
              </button>
              <div class="section-title">Partner Manager</div>
              <button class="btn btn-sm section-action" (click)="openAddPartner(addPartnerModal)">
                <i class="fas fa-user-plus"></i> Add Partner
              </button>
            </div>
            <div class="btn-group margin-b tabs" role="group" aria-label="Partner Tabs">
              <button type="button" class="btn btn-sm" [class.active]="isActiveTab('partners')"
                [ngClass]="isActiveTab('partners') ? 'main-backgroundcolor color' : 'btn-outline-secondary'"
                (click)="switchTab('partners')">Partners</button>
              <button type="button" class="btn btn-sm" [class.active]="isActiveTab('request')"
                [ngClass]="isActiveTab('request') ? 'main-backgroundcolor color' : 'btn-outline-secondary'"
                (click)="switchTab('request')">Sent Requests</button>
              <button type="button" class="btn btn-sm" [class.active]="isActiveTab('received')"
                [ngClass]="isActiveTab('received') ? 'main-backgroundcolor color' : 'btn-outline-secondary'"
                (click)="switchTab('received')">Received Requests</button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-xs-12 min-height">
            <app-no-results-found *ngIf="partners?.length == 0 && loading" hide="partner" title='Partner'>
            </app-no-results-found>

            <div *ngIf="loading">
              <div *ngFor="let props of arr">
                <app-card-skelton></app-card-skelton>
              </div>
            </div>
            <div class="card" *ngIf="!loading && partners?.length === 0">
              <div class="card-body text-center" style="color:#6c757d; font-weight:500;">
                No partner record found
              </div>
            </div>
            <div class="col-md-12" *ngIf="!loading && partners?.length > 0">
              <div class="card">
                <div class="card-header table-header main-backgroundcolor color">
                  <div class="th name">Name</div>
                  <div class="th email">Email</div>
                  <div class="th status">Status</div>
                  <div class="th action">Action</div>
                </div>
                <div class="card-body p-0">
                  <div *ngFor="let props of (partners | paginate
        : {
            itemsPerPage: itemsPerPage,
            currentPage: currentPage,
            totalItems: partners.length
          }); let i = index" class="table-row">
                    <div class="td name">
                      <div class="partner-left">
                        <img [src]="getPhoto(props) ? renderImage(getPhoto(props)) : 'assets/images/church.jpeg'"
                          (error)="$event.target.src='assets/images/church.jpeg'" alt="" class="partner-avatar">
                        <div class="flex-1">
                          <div class="partner-name truncate-1">{{ getName(props) }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="td email">
                      <div class="partner-email truncate-1">{{ getEmail(props) }}</div>
                    </div>
                    <div class="td status">
                      <ng-container *ngIf="listType === 'request'; else nonRequestStatus">
                        <span class="badge"
                          [ngClass]="props?.isApproved ? 'badge-success' : (props?.isRejected ? 'badge-danger' : 'badge-pending')">
                          {{ props?.isApproved ? 'Approved' : props?.isRejected ? 'Rejected' : 'Pending'}}
                        </span>
                      </ng-container>
                      <ng-template #nonRequestStatus>
                        <ng-container *ngIf="listType === 'received'; else partnerStatus">
                          <span class="badge"
                            [ngClass]="props?.isApproved ? 'badge-success' : (props?.isRejected ? 'badge-danger' : 'badge-pending')">
                            {{ props?.isApproved ? 'Approved' : props?.isRejected ? 'Rejected' : 'Pending' }}
                          </span>
                        </ng-container>
                        <ng-template #partnerStatus>
                          <span class="badge" [ngClass]="'badge-success'">Partner</span>
                        </ng-template>
                      </ng-template>
                    </div>
                    <div class="td action">
                      <div class="action-buttons">
                        <ng-container *ngIf="!listType">
                          <button type="button" class="btn btn-sm btn-outline-danger"
                            (click)="onRemovePartner(props?._id)">Remove</button>
                        </ng-container>
                        <ng-container *ngIf="listType === 'received'">
                          <button type="button" class="btn btn-sm btn-success"
                            (click)="onApproveRequest(props, true)" [disabled]="props?.isApproved">Approve</button>
                          <button type="button" class="btn btn-sm btn-outline-danger"
                            (click)="onApproveRequest(props, false)" [disabled]="props?.isRejected">Reject</button>
                        </ng-container>
                        <!-- <ng-container
                          *ngIf="listType === 'received' && !props?.isApproved && !props?.isRejected">
                          <button
                            type="button"
                            class="btn btn-sm btn-success"
                            (click)="onApproveRequest(props, true)">
                            Approve
                          </button>
                          <button
                            type="button"
                            class="btn btn-sm btn-outline-danger"
                            (click)="onApproveRequest(props, false)">
                            Reject
                          </button>
                        </ng-container> -->

                        <ng-container *ngIf="listType === 'request'">
                          <button type="button" class="btn btn-sm btn-outline-danger"
                            (click)="onCancelSentRequest(props)" [disabled]="props?.isRejected && !props?.isApproved">
                            Cancel
                          </button>
                        </ng-container>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="partners.length > 2" class="col-md-12" style="text-align: center;">
              <pagination-controls class="col s12 col-md-offset-3 my-pagination" *ngIf="partners?.length > 0 "
                (pageChange)="page = setPagination($event)" directionLinks="true" autoHide="false" responsive="true"
                previousLabel="Previous" nextLabel="Next" screenReaderPaginationLabel="Pagination"
                screenReaderPageLabel="page" screenReaderCurrentLabel="You're on page">
              </pagination-controls>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Community Selector Modal -->
<ng-template #communitySelectorModal let-modal>
  <div class="modal-header main-backgroundcolor">
    <h4 class="modal-title color">Select Partner</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true" class="color">&times;</span>
    </button>
  </div>
  <div class="modal-body" (scroll)="onSelectorScroll($event)" style="max-height: 420px; overflow: auto;">
    <div class="form-group">
      <input type="text" class="form-control" placeholder="Search communities"
        (input)="onCommunitySearchChange($event)">
    </div>
    <div *ngFor="let c of filteredCommunities" class="card margin-b">
      <div class="card-body community-card">
        <div class="community-left">
          <img [src]="c.photo || 'assets/images/church.jpeg'" (error)="$event.target.src='assets/images/church.jpeg'"
            alt="" style="width:50px;height:50px;border-radius:4px;object-fit:cover;">
          <div class="flex-1">
            <div class="truncate-1" style="font-weight:600;">{{ c.name }}</div>
            <div class="text-muted small truncate-1">{{ c.shortBio }}</div>
          </div>
        </div>
        <div class="checkbox-col">
          <input type="checkbox" [checked]="isCommunitySelected(c._id)" (change)="toggleCommunitySelection(c)">
        </div>
      </div>
    </div>
    <div class="text-center" *ngIf="selLoading" style="padding:8px;color:#6c757d;">Loading...</div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel')">Cancel</button>
    <button type="button" class="btn main-backgroundcolor color" (click)="modal.close('selected')">Select</button>
  </div>
</ng-template>

<!-- Add Partner Modal -->
<ng-template #addPartnerModal let-modal>
  <div class="modal-header main-backgroundcolor">
    <h4 class="modal-title color">Add Partner</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true" class="color">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label>Choose Partner</label>
      <div class="input-group">
        <input type="text" class="form-control" [value]="partnerName || ''" placeholder="Choose partner" readonly
          (click)="openCommunitySelector(communitySelectorModal)">
        <div class="input-group-append">
          <button type="button" class="btn main-backgroundcolor color"
            (click)="openCommunitySelector(communitySelectorModal)">Select</button>
        </div>
      </div>
      <small class="text-muted" *ngIf="!partnerName">No partner selected</small>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel')">Cancel</button>
    <button type="button" class="btn main-backgroundcolor color" (click)="submitAddPartner(modal)">Add</button>
  </div>
</ng-template>